export enum CalculationChoicesBoxTypeEnum {
  Simple = 'simple',
  Extended = 'extended',
}
